
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analytics/community",
      function () {
        return require("private-next-pages/analytics/community.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/analytics/community"])
      });
    }
  